type Action = {
  type: string;
  payload: boolean;
};

const reducer = (state = true, action: Action): boolean => {
  switch (action.type) {
    case 'collapse':
      return (state = action.payload);

    default:
      return state;
  }
};

export default reducer;
